import React, { useState } from "react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import getUserGroup from "../../shared/components/getUserGroup.js";
import Preloader from "../../shared/components/Preloader";
import "../styles/PatientSearch.css";

const PatientSearch = ({ onSelectPatient }) => {
  const [searchValue, setSearchValue] = useState("");
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isValidSearchInput = (value) => {
    const isValidDNI = /^\d{6,10}$/.test(value);

    const isValidName = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value);

    return isValidDNI || isValidName;
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResults([]);

    const trimmedSearch = searchValue.trim();

    if (!trimmedSearch) {
      setError("Ingresa un criterio de búsqueda válido.");
      setLoading(false);
      return;
    }

    if (!isValidSearchInput(trimmedSearch)) {
      setError(
        "El criterio de búsqueda no es válido. Usa solo letras o un número de documento de 6 a 10 dígitos."
      );
      setLoading(false);
      return;
    }

    try {
      const db = getFirestore();
      const group = await getUserGroup();

      if (!group) {
        setError("No se pudo obtener la información del grupo.");
        setLoading(false);
        return;
      }

      const patientsCollection = collection(db, "registeredPatients");
      const searchQuery = query(
        patientsCollection,
        where("group", "==", group)
      );
      const querySnapshot = await getDocs(searchQuery);

      let patients = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter(
          (patient) =>
            patient.document === trimmedSearch ||
            patient.name.toLowerCase().includes(trimmedSearch.toLowerCase()) ||
            patient.surname.toLowerCase().includes(trimmedSearch.toLowerCase())
        );

      if (patients.length === 0) {
        setError("No hay pacientes que coincidan con la búsqueda.");
      } else {
        patients.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { sensitivity: "base" })
        );
        setResults(patients);
      }
    } catch (error) {
      setError("Se produjo un error al realizar la búsqueda.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Buscar pacientes</h2>
      {error && <p className="errorText">{error}</p>}
      <form onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="Ingresá nombre, apellido o documento"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          className="generalFormInput"
        />
        <button type="submit">Buscar</button>
      </form>

      {loading ? (
        <Preloader />
      ) : (
        results.length > 0 && (
          <table className="patientTable">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Nombre</th>
                <th>Apellido</th>
              </tr>
            </thead>
            <tbody>
              {results.map((patient) => (
                <tr
                  key={patient.id}
                  onClick={() =>
                    typeof onSelectPatient === "function" &&
                    onSelectPatient(patient)
                  }
                  className="patientRow"
                >
                  <td>{patient.document}</td>
                  <td>{patient.name}</td>
                  <td>{patient.surname}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}
    </div>
  );
};

export default PatientSearch;
